import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchScreen({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="gohy2kxl3a" fill="#fff">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8zm0 2a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8z"/>
            </mask>
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8zm0 2a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8z"/>
            <path fill={fill} d="M7 4a1 1 0 0 1 1-1V1a3 3 0 0 0-3 3h2zm0 16V4H5v16h2zm1 1a1 1 0 0 1-1-1H5a3 3 0 0 0 3 3v-2zm8 0H8v2h8v-2zm1-1a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2zm0-16v16h2V4h-2zm-1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2zM8 3h8V1H8v2zm0 2V3a2 2 0 0 0-2 2h2zm0 15V5H6v15h2zm0 0H6a2 2 0 0 0 2 2v-2zm8 0H8v2h8v-2zm0 0v2a2 2 0 0 0 2-2h-2zm0-15v15h2V5h-2zm0 0h2a2 2 0 0 0-2-2v2zM8 5h8V3H8v2z" mask="url(#gohy2kxl3a)"/>
        </svg>
    );
}

export default IconSearchScreen;
